import React, { createContext, ReactElement, useState, useContext, useCallback } from "react";
import ConfiguracaoService from "../../services/ConfiguracaoService";
import { trackPromise } from "react-promise-tracker";
import Swal from "sweetalert2";
import { ConfiguracaoType, UsuarioTipoPermissaoType } from "./types";
import guService from "../../services/GuService";

interface ConfiguracaoContextProps {
    listaConfiguracoes: ConfiguracaoType[];
    recarregarConfiguracaos: () => void;
    openMenuMobile: boolean;
    setOpenMenuMobile: React.Dispatch<React.SetStateAction<boolean>>;
    fluxoAtendimentoPadrao: number;
    setFluxoAtendimentoPadrao: React.Dispatch<React.SetStateAction<number>>;
    buscarConfiguracaoPorChave: (chave:string) => any;
    listaUsuarioTipoPermissoes: UsuarioTipoPermissaoType[];
    setListaUsuarioTipoPermissoes: React.Dispatch<React.SetStateAction<UsuarioTipoPermissaoType[]>>;
}

export const ConfiguracaoContext = createContext({} as ConfiguracaoContextProps);

export function ConfiguracaoProvider({ children }: { children: ReactElement }) {
    const [listaConfiguracoes, setListaConfiguracoes] = useState<ConfiguracaoType[]>([]);
    const [openMenuMobile, setOpenMenuMobile] = useState(false);
    const [fluxoAtendimentoPadrao, setFluxoAtendimentoPadrao] = useState(Number(guService.getLocalState('fluxoAtendimentoPadrao')))
    const [listaUsuarioTipoPermissoes, setListaUsuarioTipoPermissoes] = useState([] as UsuarioTipoPermissaoType[]);

    const buscarConfiguracaoPorChave = useCallback((chave:string)=>{
      return listaConfiguracoes.find((item) => item.chave === chave)?.valor ?? false;
    },[listaConfiguracoes])

    const recarregarConfiguracaos = () => {
        trackPromise(ConfiguracaoService.index())
            .then((response) => {
                setListaConfiguracoes(response.data);
            })
            .catch((error) => {
                Swal.fire({
                    title: "Ooops...",
                    text: `Houve um erro ao carregar as configurações: ${error?.response?.status}, Erro: ${error?.response?.data?.message}, ${error}`,
                    icon: 'error'
                })
            });
    };

    return (
        <ConfiguracaoContext.Provider
            value={{
                listaConfiguracoes,
                recarregarConfiguracaos,
                openMenuMobile, 
                setOpenMenuMobile,
                fluxoAtendimentoPadrao,
                setFluxoAtendimentoPadrao,
                buscarConfiguracaoPorChave,
                listaUsuarioTipoPermissoes,
                setListaUsuarioTipoPermissoes,
            }}
        >
            {children}
        </ConfiguracaoContext.Provider>
    );
}
